import {
  Box,
  Table,
  Paper,
  TableContainer,
  makeStyles,
} from "@material-ui/core";

export default function BaseTable(props) {
  const { children, tableId, boxProps, ...rest } = props;
  const classes = useStyles();
  return (
    <Box mt={1} className={classes.box} {...boxProps}>
      <TableContainer component={Paper} className={classes.container}>
        <Table stickyHeader className={classes.table} id={tableId} {...rest}>
          {children}
        </Table>
      </TableContainer>
    </Box>
  );
}
const useStyles = makeStyles((theme) => ({
  container: {
    maxHeight: "100%",
    // borderRadius: "22px 22px 22px 22px",
  },
  box: {
    display: "inline-grid",
    // height: "calc(100vh - 247px)",
    height: "calc(100vh - 200px)",
    width: "100%",
  },
  // table: {
  //   tableLayout: "fixed",
  // },
}));
